import type { MetapolicyCalculationType } from './types';

export const getLabelOfCalculationType = (
  calculation_type: MetapolicyCalculationType,
) => {
  switch (calculation_type) {
    case 0:
      return `/чел.`;
    case 1:
      return `/ночь за чел.`;
    case 2:
      return `/ночь`;
    default:
      return '';
  }
};
